class VATFunctionalty {
    constructor() {
        this.selectors = {
            vatSidecartCheckbox: "#sideCartVatCheckbox",
            vatCartCheckbox: "#cartVatCheckbox"
        }
        this.init();
        this.init = this.init;
        this.initListeners = this.initListeners;
        this.prefillValues = this.prefillValues;
    }
    
    init(){
        this.initListeners();
        this.prefillValues();
    }

    prefillValues() {
        const isVatEnable = localStorage.getItem('VAT');
        const vatReasonValue = localStorage.getItem('VATReason');
        const clickEvent = new Event('click')

        if (isVatEnable && isVatEnable == "true") {
            if (document.getElementById('sideCartVatCheckbox')) {
                document.getElementById('sideCartVatCheckbox').dispatchEvent(clickEvent)
                document.getElementById('sideCartVatCheckbox').setAttribute('checked', true)
            }
            
            if(document.getElementById('cartVatCheckbox')) {
                document.getElementById('cartVatCheckbox').dispatchEvent(clickEvent)
                document.getElementById('cartVatCheckbox').setAttribute('checked', true)
            }
        }

        if (vatReasonValue && vatReasonValue.length) {
            if (document.getElementById("sideCartVatInput")) {
                document.getElementById("sideCartVatInput").value = vatReasonValue
            }
            
            if (document.getElementById("cartVatInput")) {
                document.getElementById("cartVatInput").value = vatReasonValue
            }
        }
    }

    initListeners() {
        if (document.getElementById("cartVatCheckbox")) {
            document.getElementById("cartVatCheckbox").addEventListener('click', (e)=>{
                const wrapper = e.target.closest('.vat-elements')
                if(e.target.closest(this.selectors.vatCartCheckbox)){
                const checkoutBtn = document.querySelector('.checkout-btn')
                if(checkoutBtn) {
                    const checkoutUrl = checkoutBtn.getAttribute('href')
                    if (!checkoutUrl.includes('discount')) {
                        checkoutBtn.setAttribute('href', `${checkoutUrl}/?discount=${window.vat.vatDiscountCode}`);
                        localStorage.setItem("VAT", "true")
                        wrapper.classList.add("active")
                    } else {
                        checkoutBtn.setAttribute('href', `${checkoutUrl.replace(`/?discount=${window.vat.vatDiscountCode}`, "")}`)
                        localStorage.setItem("VAT", "false")
                        wrapper.classList.remove("active")
                    }
                }
                }
            })
        }

        if (document.getElementById("sideCartVatInput")) {
            document.getElementById("sideCartVatInput").addEventListener('input', (e)=>{
                const value = e.target.value;
                localStorage.setItem("VATReason", value)
            })
        }

        if(document.getElementById("sideCartVatCheckbox")) {
            document.getElementById("sideCartVatCheckbox").addEventListener('click', (e)=>{
                const wrapper = e.target.closest('.vat-elements')
                if(e.target.closest(this.selectors.vatSidecartCheckbox)){
                    const checkoutBtn = document.querySelector('.checkout');
                    if(checkoutBtn) {
                        const checkoutUrl = checkoutBtn.getAttribute('href')
                        if (!checkoutUrl.includes('discount')) {
                            checkoutBtn.setAttribute('href', `/discount/${window.vat.vatDiscountCode}?redirect=${checkoutUrl}`);
                            localStorage.setItem("VAT", "true")
                            wrapper.classList.add("active")
                        } else {
                            checkoutBtn.setAttribute('href', `${checkoutUrl.replace(`/discount/${window.vat.vatDiscountCode}?redirect=`, "")}`)
                            localStorage.setItem("VAT", "false")
                            wrapper.classList.remove("active")
                        }
                    }
                }
            })
        }

        if (document.getElementById("cartVatInput")) {
            document.getElementById("cartVatInput").addEventListener('input', (e)=>{
                const value = e.target.value;
                localStorage.setItem("VATReason", value)
            })
        }

        let checkSideCartInput;
        checkSideCartInput = (event) =>{
            const href = event.target.getAttribute('href')
            const input = document.getElementById("sideCartVatInput")
            const checkoutBtn = document.getElementById('sideCartCheckoutBtn');
            if (href.includes("discount") && document.getElementById("sideCartVatInput")) {
                event.preventDefault();
                const isValid = input.reportValidity();
                if(isValid) {
                    checkoutBtn.removeEventListener('click', checkSideCartInput, false);
                    this.updateCartNotes(input.value).then(()=>{
                        checkoutBtn.click()
                    });
                }
            } else {
                checkoutBtn.removeEventListener('click', checkSideCartInput, false);
                checkoutBtn.click()
            }
        }

        let checkCartInput;

        checkCartInput = (event) =>{
            const href = event.target.getAttribute('href');
            const input = document.getElementById("cartVatInput");
            const checkoutBtn = document.getElementById('cartCheckoutBtn');
            if (href.includes("discount") && document.getElementById("cartVatInput")) {
                event.preventDefault();
                const isValid = input.reportValidity();
                if(isValid) {
                    checkoutBtn.removeEventListener('click', checkCartInput);
                    fetch('cart/update.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json;charset=UTF-8'
                            },
                            body: JSON.stringify({note: input.value})
                        }).then(()=>{
                            checkoutBtn.click();
                        })
                }
            } else {
                checkoutBtn.removeEventListener('click', checkCartInput);
                checkoutBtn.click();
            }
        }

        if(document.getElementById('sideCartCheckoutBtn')) {
            document.getElementById('sideCartCheckoutBtn').addEventListener('click', checkSideCartInput, false)
        }

        if(document.getElementById('cartCheckoutBtn')) {
            document.getElementById('cartCheckoutBtn').addEventListener('click', checkCartInput)
        }
    }

    updateCartNotes(value) {
        return window.cart.update({note: value})
    }
}

const vatInit = new VATFunctionalty();
window.VATFuncionality = vatInit;